import { combineReducers } from 'redux';

import formReducer from './ducks/form';

const reducers = {
  form: formReducer,
};

export default combineReducers(reducers);
